// 西班牙语
module.exports = {
    public: {
        confirm: 'Confirmar',
        cancel: 'Cancelar',
        reset: 'Restablecer',
        search: 'Buscar',
        RefreshSucceeded: 'Actualización exitosa',
        noMoreData: 'No hay más datos',
        pullingText: 'Desliza para actualizar…',
        ReleaseText: 'Suelta para actualizar…',
        loadingText: 'Cargando…',
        noData: 'Sin registros',
        copyTxt: 'Copiar',
        copySuccess: 'Copiado con éxito',
        amount: 'Monto',
        buy: 'Comprar',
        orderNo: 'N° de orden',
        selectLang: 'Seleccionar idioma',
        light: 'Claro',
        dark: 'Oscuro',
        All: 'Todo',
        DigitalCurrency: 'Criptomoneda',
        foreignExchange: 'Forex',
        futures: 'Futuros',
        stockIndex: 'Índice bursátil',
        stock: 'Acción',
        BalanceNot: 'Saldo insuficiente',
        optional: 'Opcional',
        market: 'Mercado',
        USDTcontract: 'Contrato USDT',
        Fiatcurrencycontract: 'Contrato Fiat',
        spot: 'Spot',
        secondContract: 'Contrato por segundos',
        emptyTxt: 'Sin registros',
    },
    tabBar: {
        home: 'Inicio',
        market: 'Descubrir',
        trade: 'Operar',
        heel: 'Gestión financiera',
        asset: 'Activos',
    },
    about: {
        title: 'Sobre nosotros',
        version: 'Versión',
        about: 'Acerca de',
        ProductIntroduction: 'Introducción',
        Termofservice: 'Términos',
        PrivacyAgreement: 'Privacidad',
        Riskstatement: 'Riesgos',
        whitePaper: 'Libro Blanco',
    },
    asset: {
        Overview: 'Resumen',
        contract: 'Contrato',
        wallet: 'Billetera',
        Totalassetvaluation: 'Valor total',
        supportswithdrawal: 'Todos los depósitos son retirables',
        Recharge: 'Recargar',
        Contractaccount: 'Cuenta de contrato',
        Spotaccount: 'Cuenta spot',
        Walletaccount: 'Cuenta billetera',
        ValuationContractAssets: 'Valor contrato',
        profitloss: 'Ganancias/Pérdidas',
        Transfer: 'Transferir',
        occupy: 'Bloqueo',
        available: 'Disponible',
        Viewallpositions: 'Ver todas las posiciones',
        Valuationspotassets: 'Valor spot',
        Hidezerobalanceassets: 'Ocultar saldos en cero',
        balance: 'Saldo',
        ValuationWalletAssets: 'Valor billetera',
        Withdrawal: 'Retiro',
        Walletbalance: 'Saldo billetera',
        Cryptocurrencyrecharge: 'Recarga cripto',
        Fiatcurrencyrecharge: 'Recarga fiat',
        From: 'Desde',
        To: 'Hasta',
        UsdtContractaccount: 'Cuenta contrato USDT',
        FiatContractaccount: 'Cuenta contrato Fiat',
        Currency: 'Moneda',
        quantity: 'Cantidad',
        availablebalance: 'Saldo disponible',
        Insufficientavailablebalance: 'Saldo insuficiente',
        Transfersuccessful: 'Transferencia exitosa',
        flashcash: 'Cambio rápido',
        flashcashsuccessful: 'Cambio rápido exitoso',
    },
    auth: {
        title: 'Verificación',
        gj: 'Nacionalidad',
        tipsgj: 'Seleccione nacionalidad',
        userName: 'Nombre real',
        tips1: 'Ingrese su nombre real',
        IDNumber: 'N° de documento',
        tips2: 'Ingrese su documento',
        base: 'Básico',
        high: 'Avanzado',
        zmz: 'Foto frontal',
        bmz: 'Foto trasera',
        tips3: 'Suba foto frontal',
        tips4: 'Suba foto trasera',
        btn: 'Enviar',
        upbtn: 'Actualizar documento',
        subMsg: 'Enviado, espere revisión',
        upMsg: 'Al modificar, se volverá a revisar. ¿Confirmar?',
        wait: 'En revisión',
        fail: 'Fallido',
        success: 'Aprobado',
        cardType: 'Tipo de documento',
        idCard: 'DNI',
        passport: 'Pasaporte',
        driverlicense: 'Licencia',
        AssetCertification: 'Certificación de activos',
        AccountType: 'Tipo de cuenta',
        holdingamount: 'Monto en posesión',
        Accountscreenshot: 'Captura de pantalla de la cuenta',
        bankaccount: 'Cuenta bancaria',
        IRAaccount: 'Cuenta IRA',
        stockaccount: 'Cuenta de acciones',
        other: 'Otros',
        AccountTypetips: 'Por favor seleccione el tipo de cuenta',
        Accountscreenshottips: 'Por favor cargue la captura de pantalla de la cuenta',
    },
    activity: {
        toptit: 'Beneficios',
        inviteTxt: 'Por cada amigo que invites recibirás {amount} USD, con soporte para comisiones de hasta tres niveles',
        invitebtn: 'Invitar y ganar comisión',
        rechargeTxt: 'Cuando tu referido recargue, recibirás una comisión del {amount}%, con soporte para comisiones de hasta tres niveles',
        rechargebtn: 'Comisión por recarga',
        authTxt: 'Recibe {amount} USD al completar la verificación de identidad',
        authbtn: 'Verificación de identidad',
        inviteRewardTxt: '<p><strong>Invita amigos y recibe 30 USD fácilmente</strong></p><p><br></p><p>1. Objetivo del programa</p><p><br></p><p>Dirigido a: Usuarios nuevos y existentes, incentivando a los usuarios activos a invitar amigos a registrarse y realizar acciones específicas, con el fin de ampliar la base de usuarios de la plataforma.</p><p>Núcleo: Mediante un sistema de referidos, permitir que los nuevos usuarios se incorporen rápidamente y generen crecimiento viral, mientras los que invitan reciben recompensas reales, incrementando la retención y lealtad de usuarios.</p><p><br></p><p>2. Duración del programa</p><p><br></p><p>20/05/2023 – Vigencia prolongada (sujeto a revisión o finalización con previo aviso).</p><p><br></p><p>3. Participantes</p><p><br></p><p>Cualquier usuario que haya registrado cuenta en la plataforma y completado la verificación de identidad básica puede ser invitador (A).</p><p>El invitado (B) será considerado válido si se registra mediante el enlace o código de invitación y completa la verificación de identidad.</p><p><br></p><p>4. Reglas de participación</p><p><br></p><p>Cómo invitar:</p><p>El invitador (A) accede a “Perfil personal” → “Invitar amigos” → copia su enlace o código de invitación;</p><p>Lo comparte con amigos (B) para que se registren a través de la web o app.</p><p><br></p><p>Requisitos para el invitado:</p><p>B debe usar el enlace o código de A para su primer registro;</p><p>Dentro de los 7 días debe completar la verificación de identidad y alcanzar el depósito mínimo (por ejemplo: depósito inicial ≥ 1000 USD o equivalente).</p><p><br></p><p>Jerarquías:</p><p>El programa soporta hasta 3 niveles de comisión.</p><p>Nivel 1 (directo): A invita directamente a B.</p><p>Nivel 2: B invita a C, A recibe comisión de nivel 2;</p><p>Nivel 3: C invita a D, A recibe comisión de nivel 3;</p><p>Más allá del nivel 3 (D invita a E, etc.) no genera beneficios para A.</p><p><br></p><p>5. Detalles de recompensas</p><p><br></p><p>Recompensa Nivel 1 (directo):</p><p>Si B realiza el depósito y la verificación de identidad, A recibe 30 USD.</p><p><br></p><p>Recompensa Nivel 2 (indirecto):</p><p>Si B invita a C y éste cumple los requisitos, A recibe 15 USD.</p><p><br></p><p>Recompensa Nivel 3:</p><p>Si C invita a D y cumple los requisitos, A recibe 10 USD.</p><p><br></p><p>Forma de entrega:</p><p>El sistema detecta automáticamente la relación de hasta tres niveles; cuando un referido cumple los requisitos, A recibe la recompensa en su cuenta en un plazo de <strong>48 horas</strong>.</p><p><br></p><p>6. Ejemplo de flujo:</p><p><br></p><p>A inicia sesión en cryptorix → “Perfil personal” → “Invitar amigos” → copia enlace/código;</p><p>A envía a B;</p><p>B hace clic o ingresa el código → se registra por email → verifica identidad y deposita ≥ 1000 USD;</p><p>Tras completar, B contacta al servicio para reclamar recompensa; el sistema aprueba y envía 30 USD a A en 48 horas;</p><p>Si B invita a C que cumple requisitos, A recibe 15 USD; si C invita a D que cumple, A recibe 10 USD.</p><p><br></p><p>7. Control de riesgos y consideraciones</p><p><br></p><p>Prevención de fraude:</p><p>Cada número de teléfono o correo electrónico solo puede ser invitado una vez; el mismo IP, documentos de identidad, etc. son evaluados por sistemas de control de riesgo;</p><p>Para cuentas de baja calidad o registros masivos desde el mismo dispositivo/red, el sistema hace revisión manual y puede anular la recompensa;</p><p><br></p><p>Sanciones:</p><p>Si se detecta abuso o retiradas fraudulentas mediante el sistema de invitación, la plataforma puede cancelar recompensas y congelar la cuenta.</p><p><br></p>',
        rechargeRewardTxt: '<p><strong>Comisión por depósitos de referidos, beneficios al instante</strong></p><p><br></p><p><strong>1. Objetivo del programa</strong></p><p><br></p><p>Dirigido a: El invitador de nivel 1 (A) que haya verificado su identidad y haya invitado al menos a un referido (B, C o D); cuando estos depositan en la plataforma, A recibe una comisión según las tasas establecidas por la plataforma para fomentar la expansión de la red y la actividad de usuarios.</p><p><br></p><p>Núcleo: Mediante el esquema de “comisión por depósito”, se vincula la acción de depósito de nuevos usuarios con el beneficio del invitador, creando un ciclo “invita – deposita – recibe comisión – invita más”, impulsando retención de capital y dinamismo de la plataforma.</p><p><br></p><p><strong>2. Duración del programa</strong></p><p><br></p><p>El programa está vigente desde el 20/05/2023 de forma continua; las tasas de comisión o la duración pueden ajustarse con aviso previo.</p><p><br></p><p><strong>3. Participantes</strong></p><p><br></p><p>Invitador A: debe haber verificado identidad y haber invitado al menos a un referido B con verificación completa.</p><p><br></p><p>Referidos B, C, D: son quienes fueron invitados por A o sus referidos; cuando depositan, A recibe comisión.</p><p><br></p><p><strong>4. Reglas de participación</strong></p><p><br></p><p><strong>Estructura por niveles:</strong></p><p>Nivel 1 (B directo): B deposita ≥ 1000 USD → A recibe 1%;</p><p>Nivel 2 (C): C deposita ≥ 1000 USD → A recibe 0,5%;</p><p>Nivel 3 (D): D deposita ≥ 1000 USD → A recibe 0,3%;</p><p>Sólo hasta el nivel 3.</p><p><br></p><p><strong>Canales y depósito mínimo:</strong></p><p>Se aceptan depósitos en fiat o cripto, pero cada depósito debe ser ≥ 1000 USD para contar;</p><p><br></p><p><strong>Tasas de comisión:</strong></p><p>Nivel 1: 1,0% (ej. B deposita 1000 USD → A recibe 10 USD);</p><p><br></p><p>Nivel 2: 0,5% (C deposita 1000 USD → A recibe 5 USD);</p><p><br></p><p>Nivel 3: 0,3% (D deposita 1000 USD → A recibe 3 USD);</p><p><br></p><p><strong>Entrega de comisión:</strong></p><p>La plataforma transferirá la comisión dentro de las 24 horas posteriores al depósito;</p><p>El usuario puede revisar la fuente y hora en “Mi monedero” → “Detalle de comisiones”.</p><p><br></p><p>5. Ejemplo de flujo:</p><p><br></p><p>A inicia sesión en la app → “Perfil” → “Invitar amigos” → copia enlace/código;</p><p>A lo envía a B;</p><p>B se registra → verifica → deposita ≥ 1000 USD;</p><p>Al acreditarse los fondos, el sistema calcula automáticamente: total depositado × 1% = comisión para A; se transfiere en 24 horas;</p><p><br></p><p>Después de que B verifique, puede invitar a C; si C deposita:</p><p>B recibe C depósito × 1%;</p><p>A recibe C depósito × 0,5%;</p><p><br></p><p>C invita a D; si D deposita:</p><p>C recibe D depósito × 1%;</p><p>B recibe D depósito × 0,5%;</p><p>A recibe D depósito × 0,3%;</p><p><br></p><p><strong>6. Control de riesgos y notas:</strong></p><p><br></p><p><strong>Prevención de abuso:</strong></p><p>Un mismo usuario no puede realizar transacciones circulares; la plataforma monitorea depósitos pequeños repetidos o retiros de alta frecuencia para verificación y puede anular comisiones;</p><p>Si detecta retiros rápidos o actividad frecuente, el sistema puede cancelar la comisión;</p><p><br></p><p><strong>Cumplimiento legal:</strong></p><p>Si la plataforma detecta riesgo de lavado de dinero o retiro ilegal, puede congelar las comisiones y reportar a reguladores.</p><p><br></p>',
        authRewardTxt: '<p><strong>Verificación de identidad, recibe 50 USD</strong></p><p><br></p><p>1. Objetivo del programa</p><p><br></p><p>Dirigido a: Usuarios nuevos y antiguos (si no habían verificado su identidad anteriormente) pueden participar; busca atraer a los usuarios a verificar su identidad y mejorar la retención, además de incentivar a quienes evitan el proceso por complicaciones.</p><p>Esencia: Mediante una recompensa en efectivo directa, motivar a los usuarios a completar la verificación de identidad, mejorar el control de riesgos y la cobertura de KYC, asegurando el cumplimiento normativo de la plataforma.</p><p><br></p><p>2. Duración del programa</p><p><br></p><p>20/05/2023 – Vigencia prolongada</p><p><br></p><p>3. Participantes</p><p><br></p><p>Usuario nuevo: se registra por primera vez en cryptorix y completa la verificación durante la vigencia de la promoción;</p><p>Usuario antiguo: se había registrado antes pero no completó la verificación; debe hacerlo durante el programa para recibir la recompensa;</p><p><br></p><p>4. Reglas de verificación</p><p><br></p><p>Requisitos:</p><p>Subir fotos claras del documento (DNI/pasaporte/licencia de conducir) de ambos lados y una foto de medio cuerpo sujetando el documento;</p><p>El reconocimiento facial requiere buena iluminación, rostro despejado y cumplir con los controles de liveness;</p><p>Tras envío, la revisión suele completarse en 24 horas;</p><p><br></p><p>Recompensa:</p><p>Cada usuario que complete la verificación durante el programa (nuevo o antiguo) recibe 50 USD;</p><p><br></p><p>Desembolso:</p><p>El sistema transfiere 50 USD a la cuenta de contrato fiat en 24 horas después de la verificación; tras completar 10 transacciones normales, se puede retirar;</p><p><br></p><p>Si falta información o se rechaza, el usuario debe complementar y volver a verificar para recibir la recompensa;</p><p><br></p><p>5. Ejemplo de flujo:</p><p><br></p><p>El usuario inicia sesión en la app → “Verificación de identidad” → comienza el proceso;</p><p>Sube fotos del DNI/pasaporte/licencia de conducir;</p><p>El sistema hace comparación automática; en caso de no pasar, se solicita repetir;</p><p>Tras aprobación, el sistema transfiere 50 USD a la cuenta de contrato fiat en 24 horas;</p><p><br></p><p>6. Control de riesgos y notas:</p><p><br></p><p><strong>Prevención de fraude:</strong></p><p>Cada documento sólo puede recibir recompensa una vez; si desde la misma IP/dispositivo se suben múltiples documentos, el sistema controlará o rechazará;</p><p>Si se detectan documentos falsos o alterados, la verificación será rechazada y la cuenta bloqueada;</p><p><br></p><p><strong>Protección de datos:</strong></p><p>La plataforma se compromete a que los documentos y datos biométricos solo se utilizan para KYC y control de riesgos, sin divulgarlos sin permiso;</p><p>Tras la verificación, los documentos y videos serán encriptados y almacenados conforme a la regulación;</p><p><br></p><p>&nbsp;</p>'
    },
    bill: {
        title: 'Historial',
        audit: 'Pendiente',
        success: 'Exitoso',
        refuse: 'Rechazado',
        recharge: 'Recarga',
        recharge_currency: 'Depósito cripto',
        recharge_legal: 'Depósito fiat',
        withdrawal: 'Retiro',
        withdrawal_currency: 'Retiro cripto',
        cancel_withdrawal_currency: 'Cancelar retiro cripto',
        withdrawal_legal: 'Retiro fiat',
        cancel_withdrawal_legal: 'Cancelar retiro fiat',
        transfer: 'Transferencia',
        usdt_contract_wallet: 'Contrato USDT -> Billetera',
        legal_contract_wallet: 'Contrato Fiat -> Billetera',
        coin_currency_wallet: 'Spot -> Billetera',
        wallet_usdt_contract: 'Billetera -> Contrato USDT',
        wallet_legal_contract: 'Billetera -> Contrato Fiat',
        wallet_coin_currency: 'Billetera -> Spot',
        finance_wallet: 'Conocimientos -> Billetera',
        wallet_finance: 'Billetera -> Conocimientos',
        usdt_contract_currency: 'Contrato USDT -> Spot',
        finance_currency: 'Finanzas -> Spot',
        currency_usdt_contract: 'Spot -> Contrato USDT',
        currency_finance: 'Spot -> Finanzas',
        legal_contract_currency: 'Contrato fiat -> Spot',
        currency_legal_contract: 'Spot -> Contrato fiat',
        recharge_reward: 'Comisión por recarga de subordinado',
        auth_reward: 'Recompensa por verificación de identidad',
        flashcash: 'Cambio rápido',
        trade: 'Operación',
        create_order: 'Orden creada',
        settlement_order: 'Orden liquidada',
        cancel_order: 'Orden cancelada',
        finance_return: 'Devolución del capital',
        finance_income: 'Ganancia de inversión',
        other: 'Otros',
        commission_transfer: 'Comisión recibida',
        platform_gift: 'Bono plataforma',
        system_regulation: 'Cambios en el saldo',
        freeze_thaw: 'Congelación y descongelación',
        c2c_create_order: 'C2C Orden creada',
        c2c_cancel_order: 'C2C Orden cancelada',
        Currency: 'Moneda',
        type: 'Tipo',
        SelectCurrency: 'Seleccionar moneda',
        SelectType: 'Seleccionar tipo',
        SelectDate: 'Seleccionar fecha',
        to: 'a',
        Contractfunds: 'Fondos de contrato',
        Spotfunds: 'Fondos spot',
        Walletfunds: 'Fondos billetera',
        RechargeRecord: 'Historial de recargas',
        WithdrawalRecord: 'Historial de retiros',
        virtualcoin: 'Criptomoneda',
        Legaltender: 'Fiat',
    },
    c2c: {
        limit: 'Límite',
        available: 'Disponible',
        price: 'Precio unitario',
        needpay: 'Debe pagar',
        willreceive: 'Recibirá',
        Insufficientlimit: 'Límite insuficiente',
        Exceedinglimit: 'Excede el límite',
        Exceedingavailable: 'Excede lo disponible',
        balance: 'Saldo',
        InsufficientBalance: 'Saldo insuficiente',
        OrderHistory: 'Historial de pedidos',
        quantity: 'Cantidad',
        amountmoney: 'Importe',
        OrderNo: 'Número de pedido',
        inprogress: 'En progreso',
        Completed: 'Completado',
        Cancelled: 'Cancelado',
        all: 'Todo',
        chat: 'Chat',
        picture: '[Imagen]',
        Read: 'Leído',
        Unread: 'No leído',
        inputTips: 'Escribe tu mensaje aquí',
        send: 'Enviar',
    },
    common: {
        title: 'Funciones',
        Depositcoins: 'Depósito cripto',
        Rechargefiatcurrency: 'Depósito fiat',
        Withdraw: 'Retirar',
        documentation: 'Copiar',
        Activecenter: 'Actividades',
        Invitationforrebate: 'Invitación cashback',
        Detailsoffunds: 'Historial financiero',
        Positiondetails: 'Posiciones',
        Notice: 'Información',
        Aboutus: 'Sobre nosotros',
        helpcenter: 'Centro de ayuda',
        customer: 'Soporte',
        Cryptocurrencywithdrawal: 'Retiro cripto',
        Fiatmoneywithdrawal: 'Retiro fiat',
        DepositcoinsTips: 'Proceso sencillo, compra de monedas rápida',
        RechargefiatcurrencyTips: 'Recarga USD a través de un canal fiduciario',
        USDTcontractTips: 'Varios contratos liquidados en USDT',
        FiatcurrencycontractTips: 'Varios contratos liquidados en moneda fiduciaria',
        TransferTips: 'Cambiar un clic por un activo de criptomoneda diferente',
        c2cTips: 'Compra y vende criptomonedas con métodos de pago flexibles 0 comisiones de transacción',
    },
    forgotPass: {
        title: 'Restablecer clave',
        btn: 'Confirmar',
        Password: 'Nueva clave',
        placeholder: 'Ingrese nueva clave',
        success: 'Cambio exitoso',
    },
    finance: {
        financeAssetAmount: 'Valor estimado de activos financieros',
        financeAccount: 'Cuenta financiera',
        financefund: 'Fondos financieros',
        financeProduct: 'Producto financiero',
        Applynow: 'Solicitar ahora',
        term: 'Plazo',
        investment: 'Monto de inversión',
        Mininvestment: 'Inversión mínima',
        Maxinvestment: 'Inversión máxima',
        buyNum: 'Número de compras',
        Myincome: 'Mis ingresos',
        Dailyearnings: 'Ganancias diarias',
        yieldmaturity: 'Ganancia al vencimiento',
        timeaxis: 'Línea de tiempo',
        Subscriptiondate: 'Fecha de suscripción',
        valuedate: 'Fecha de inicio',
        duedate: 'Fecha de vencimiento',
        Receiptdate: 'Fecha de recepción',
        day: 'Día',
        financeOrderList: 'Historial financiero',
        interestrate: 'Tasa de interés',
        Revenueamount: 'Monto de ingresos',
        Settlementamount: 'Monto de liquidación',
        regularly: 'A plazo fijo',
        eecurrent: 'A la vista',
        redemption: 'Rescate',
        redemptionTips: 'Confirmar el rescate de este producto financiero',
        loan: 'Préstamo',
        LoanRange: 'Rango del préstamo',
        LoanAmount: 'Monto del préstamo',
        loanTerm: 'Plazo del préstamo',
        Dailyinterestrate: 'Tasa de interés diaria',
        Totalinterest: 'Interés total',
        Repaymentmethod: 'Método de pago',
        Repaymentofmaturity: 'Pago único de capital e intereses al vencimiento',
        Estimatedreturn: 'Monto estimado a pagar',
        Ihavereadandagree: 'He leído y acepto',
        LoanAgreement: 'Contrato de préstamo',
        Immediatelymoney: 'Solicitar préstamo ahora',
        Minimumloanamount: 'Monto mínimo del préstamo',
        Maximumloanamount: 'Monto máximo del préstamo',
        Applicationsuccessfulreview: 'Solicitud exitosa, en espera de revisión del sistema',
        Loanrecords: 'Historial de préstamos',
        Pendingreview: 'Pendiente de revisión',
        issued: 'Desembolsado',
        Repaid: 'Reembolsado',
        Rejected: 'Rechazado',
        LoanDate: 'Fecha del préstamo',
        AmountDue: 'Monto a pagar',
        repayment: 'Pago',
        loanTTips: 'Desembolso rápido, opciones flexibles de plazo de garantía',
        homeAddress: 'Dirección detallada del hogar',
        homeAddressTips: 'Por favor ingrese la dirección detallada del hogar',
        emergencyContact: 'Contacto de emergencia',
        emergencyContactTips: 'Por favor ingrese el contacto de emergencia',
        emergencyPhone: 'Número de teléfono del contacto de emergencia',
        emergencyPhoneTips: 'Por favor ingrese el número de teléfono del contacto de emergencia',
        emergencyEmail: 'Correo electrónico del contacto de emergencia',
        emergencyEmailTips: 'Por favor ingrese el correo electrónico del contacto de emergencia',
        isHouse: '¿Tiene una propiedad propia?',
        houseImg: 'Si tiene propiedad, proporcione una imagen del comprobante de propiedad',
        certImg: 'Frente del documento (ID/Pasaporte/Licencia de conducir)',
        certImgTips: 'Por favor suba el frente del documento (ID/Pasaporte/Licencia de conducir)',
        certBackImg: 'Parte trasera del documento (ID/Pasaporte/Licencia de conducir)',
        certBackImgTips: 'Por favor suba la parte trasera del documento (ID/Pasaporte/Licencia de conducir)',
        trustImg: 'Captura de pantalla del puntaje de crédito',
        trustImgTips: 'Por favor suba la captura de pantalla del puntaje de crédito',
        yesTxt: 'Sí',
        noTxt: 'No',
        EstimatedReturn: 'Ganancia estimada',
        seeDetail: 'Ver detalles',
        orderDetails: 'Detalles del pedido',
    },
    heel: {
        tips: 'Próximamente~',
    },
    home: {
        optional: 'Opcional',
        HotList: 'Lista de Populares',
        more: 'Más',
        Capturetrading: 'Aprovecha las Oportunidades de Trading',
        Exploreproducts: 'Explora Nuestros Productos',
        Contracttrading: 'Trading de Contratos',
        Spottrading: 'Gestión financiera',
        ContracttradingTips: 'Productos derivados con apalancamiento altamente populares, con hasta 100x de apalancamiento. Compatible con posiciones largas y cortas; si hay volatilidad, hay oportunidad de ganancias.',
        SpottradingTips: 'El menor costo, la mayor rentabilidad. Opera en cualquier momento y lugar.',
        starttrading: 'Comenzar a Operar',
        Tradeanytime: 'Opera en Cualquier Momento y Lugar',
        Scandownload: 'Escanea para Descargar',
        hundredmillion: 'Cien millones',
        thousand: 'Mil',
        year: 'Año',
        transactionvolume: 'Volumen de Transacciones en 24 Horas',
        openinterest: 'Interés Abierto en 24 Horas',
        RegisteredUser: 'Usuarios Registrados',
        Ensuresafetyfunds: 'Garantiza la Seguridad de los Fondos',
        Reasonschoosingus: 'Razones para Elegirnos',
        mobeginwith: 'Fundado en',
        Topliquidity: 'Alta Liquidez',
        Effectivelyusers: 'Protección Efectiva de los Usuarios',
        TradeNow: 'Operar Ahora',
        Needhelp: '¿Necesitas Ayuda',
        helpcenter: 'Centro de Ayuda',
        helpcenterTips: 'Brindamos asistencia para preguntas frecuentes y explicaciones detalladas sobre funciones específicas.',
        Learnmore: 'Aprender Más',
        Onlinecustomerservice: 'Servicio al Cliente en Línea',
        OnlinecustomerserviceTips: 'Soporte 24/7 disponible en todo momento y lugar.',
        PlatformAnnouncement: 'Anuncios de la Plataforma',
        PlatformAnnouncementTips: 'Recibe información actualizada y mantente al tanto de las oportunidades de trading.',
        Starttradingnow: '¡Comienza tu viaje en el trading de criptomonedas ahora!',
        Trademillions: 'Opera en una plataforma en la que confían millones de usuarios',
        Storingbuyingcoins: 'Depositar o Comprar Criptomonedas',
        product: 'Productos',
        service: 'Servicios',
        guide: 'Guía',
        agreedannouncement: 'Acuerdos y Declaraciones',
        customerservice: 'Atención al Cliente',
        Riskstatement: 'Declaración de Riesgo: El trading de activos digitales es una industria emergente con un gran potencial, pero también con grandes riesgos debido a su novedad. En particular, el trading con apalancamiento amplifica tanto las ganancias como los riesgos. Es fundamental comprender la industria, los modelos de trading con apalancamiento y las reglas del mercado antes de participar. Te recomendamos encarecidamente que operes dentro de los límites de riesgo que puedas asumir. El trading conlleva riesgos, ¡opera con precaución!',
        topTips: 'Una cuenta, infinitas posibilidades',
        coin: 'Comercio al contado',
        coinTips: 'Instantáneo y transparente, comienza tu viaje de comercio al contado en cualquier momento y en cualquier lugar',
    },
    login: {
        title: 'Iniciar sesión',
        Account: 'Cuenta',
        Password: 'Contraseña',
        btn: 'Ingresar',
        placeholder: 'Ingrese número',
        placeholder1: 'Ingrese clave',
        ForgotPassword: 'Olvidé clave',
        noAccount: '¿Sin cuenta?',
        Registration: 'Registrarse',
        server: 'Soporte',
        success: 'Inicio exitoso',
        checkedAgree: 'Acepte privacidad',
        rememberpassword: 'Recordar clave',
        agreewith: 'Aceptar',
        PrivacyAgreement: 'Privacidad',
    },
    market: {
        product: 'Producto',
        Latestprice: 'Último precio',
        volume: 'Volumen',
        ChangeRatio: 'Variación',
        Addoptional: 'Añadir a favoritos',
        optional: 'Favoritos',
        market: 'Mercado',
        Editselfselection: 'Editar favoritos',
        operate: 'Operar',
        SelectAll: 'Seleccionar todo',
        delete: 'Eliminar',
        time: 'Tiempo',
    },
    position: {
        title: 'Posiciones',
        totalassets: 'Total activos',
        profitloss: 'Gan/Pérd',
        Holdingassets: 'Activos en posición',
        margin: 'Margen',
        orderAmount: 'Monto orden',
        availableassets: 'Activos disponibles',
        product: 'Producto',
        direction: 'Dirección',
        Entrustedprice: 'Precio ordenado',
        Entrustednum: 'Cantidad ordenada',
        Currentprice: 'Precio actual',
        Stoplossprice: 'Stop loss',
        stopSurplusPrice: 'Take profit',
        Leverageratio: 'Apalancamiento',
        Entrustedtime: 'Hora orden',
        orderno: 'N° orden',
        marketvalue: 'Valor mercado',
        SettlementPrice: 'Precio liquidación',
        Settlementtime: 'Hora liquidación',
        Settakeprofitloss: 'Configurar SL/TP',
        closeposition: 'Cerrar posición',
        Position: 'Órdenes abiertas',
        commission: 'Órdenes históricas',
        Settlement: 'Historial de operaciones',
        Settingsuccessful: 'Configurado con éxito',
        Confirmclosingorder: 'Confirmar cierre de orden',
        Closingsuccessfully: 'Cierre exitoso',
        cancelorder: 'Confirmar cancelación de orden',
        Cancelsuccessfully: 'Cancelado con éxito',
        status: 'Estado',
        changeRate: 'Comisión',
    },
    property: {
        title: 'Detalle activos',
        totalassets: 'Total activos',
        profitloss: 'Gan/Pérd',
        Holdingassets: 'Activos en posición',
        margin: 'Margen',
        availableassets: 'Activos disponibles',
        investmentportfolio: 'Portafolio',
        Recentincomesituation: 'Últimas ganancias',
        Seemore: 'Ver más',
        IncomeDetails: 'Detalle de ingresos',
    },
    recharge: {
        mixAmount: 'Mín. recarga',
        subMsg: 'Enviado, espere revisión',
        amountMsg: 'Ingrese monto',
        VoucherMsg: 'Suba comprobante',
        Depositcoins: 'Depósito cripto',
        Rechargecurrency: 'Moneda',
        RechargecurrencyTips: 'Depósito > 200USDT, rápido',
        Depositaddress: 'Dirección',
        Rechargetoaccount: 'Cuenta destino',
        Walletaccount: 'Billetera',
        Rechargequantity: 'Cantidad',
        Paymentvoucher: 'Comprobante',
        Youneedtorecharge: 'Debe recargar',
        Rechargenow: 'Recargar ahora',
        Rechargefiatcurrency: 'Depósito fiat',
        Topupfiatcurrency: 'Recarga fiat',
        paymentcurrency: 'Moneda de pago',
        paymentcurrencyTips: 'Depósito > 200USD, rápido',
        Fiatcontractaccount: 'Cuenta Fiat',
        Rechargeamount: 'Monto',
        Youwillget: 'Recibirá',
        network: 'Red',
        notsupportedAddress: 'Dirección no soportada',
        selectaccount: 'Selecciona una cuenta',
    },
    register: {
        title: 'Registro',
        send: 'Enviar código',
        Resend: 'Reenviar',
        sendSuccess: 'Enviado',
        PhoneNumber: 'Teléfono',
        Mailbox: 'Correo',
        Captcha: 'Código',
        Password: 'Clave',
        ConfirmPassword: 'Confirmar clave',
        PromoteCode: 'Código promo',
        OrgCode: 'Código org.',
        btn: 'Registrarse',
        placeholder0: 'Ingrese teléfono',
        placeholder1: 'Ingrese clave',
        placeholder2: 'Confirmar clave',
        placeholder3: 'Ingrese ID referido',
        placeholder4: 'Ingrese código',
        placeholder5: 'Ingrese correo',
        emaiError: 'Formato incorrecto',
        success: 'Registro exitoso',
        message: 'Clave min. 6 caracteres',
        message1: 'Confirmar clave min. 6 caracteres',
        message2: 'Las claves no coinciden',
        searchCountryMsg: 'Busque país/código',
        haveAccount: '¿Ya tiene cuenta?',
        goLogin: 'Iniciar sesión',
        titleTips: '¡Empiece ahora!',
        Invitationcode: 'Código invitación',
        Iagreewith: 'Al registrarse, acepta',
        and: 'y',
    },
    safe: {
        SecuritySettings: 'Seguridad',
        Accountsecurity: 'Seguridad cuenta',
        phone: 'Teléfono',
        Notyetbound: 'No vinculado',
        mailbox: 'Correo',
        Loginpassword: 'Clave de acceso',
        Fundcode: 'Clave de fondos',
        Settings: 'Configurar',
        Withdrawaladdressmanagement: 'Gestión de retiros',
        Addwithdrawaladdress: 'Añadir dirección',
        Withdrawalcurrency: 'Moneda de retiro',
        Withdrawaladdress: 'Dirección de retiro',
        WithdrawaladdressTips: 'Ingrese dirección',
        remark: 'Nota',
        confirm: 'Confirmar',
        Addedsuccessfully: 'Añadido con éxito',
        Pleaseselectcurrency: 'Seleccione moneda',
        Bindmailbox: 'Vincular correo',
        Bindmobilephone: 'Vincular teléfono',
        ChangeLoginPassword: 'Cambiar clave',
        Setfundpassword: 'Configurar clave fondos',
        BindmailboxTips: 'Vincule su correo primero',
        Addnewaddress: 'Añadir nueva dirección',
        Confirmdeleteaddress: 'Confirmar eliminación',
    },
    share: {
        title: 'Gana compartiendo',
        commission: 'Comisión',
        Commissionrecord: 'Historial de comisiones',
        Commissiontransferout: 'Retiro de comisión',
        Transferoutrecord: 'Historial de retiros',
        Invitefriends: 'Invitar amigos',
        Invitationrecord: 'Historial de invitaciones',
        Commissioncommission: 'Comisión ganada',
        ReferralCode: 'Código de referencia',
        Firstlevelmembers: 'Miembros nivel 1',
        Secondlevelmembers: 'Miembros nivel 2',
        Thirdlevelmembers: 'Miembros nivel 3',
        Transferbalance: 'Transferir a saldo',
        Confirmtransferout: 'Confirmar retiro',
        Transfersuccessful: 'Retiro exitoso',
        amount: 'Monto a retirar',
        Transferfiaaccount: 'Transferir a cuenta Fiat',
    },
    trade: {
        high: 'Máx 24h',
        low: 'Mín 24h',
        vol: 'Volumen 24h',
        buy: 'Comprar',
        sell: 'Vender',
        buyBtn: 'Compra',
        sellBtn: 'Venta',
        Present: 'Orden de mercado',
        Limit: 'Orden límite',
        limitMsg: 'Precio',
        markPriceMsg: 'Al mejor precio disponible',
        num: 'Cantidad',
        zyzsSet: 'Configurar SL/TP',
        zyPrice: 'Take profit',
        zsPrice: 'Stop loss',
        smallMin: 'M',
        hour: 'H',
        dayMin: 'D',
        Position: 'Posiciones',
        Viewalltransactions: 'Ver todas las operaciones',
        product: 'Producto',
        direction: 'Dirección',
        Entrustedprice: 'Precio límite',
        Entrustednum: 'Cantidad ordenada',
        Latestprice: 'Último precio',
        volume: 'Volumen',
        ChangeRatio: 'Variación',
        buyBtnConfirm: 'Confirmar compra',
        sellBtnConfirm: 'Confirmar venta',
        totalAmount: 'Monto total',
        Margin: 'Margen',
        balance: 'Saldo disponible',
        buyLimtMsg: 'Comprar solo con precio menor al mercado',
        sellLimtMsg: 'Vender solo con precio mayor al mercado',
        putNummsg: 'Ingrese cantidad',
        putLimitPriceMsg: 'Ingrese precio límite',
        pleaseAuth: 'Realice verificación de identidad',
        orderSuccess: 'Orden exitosa',
        Fullwarehouse: 'Todo',
        corkado: 'Apertura larga disponible',
        Kato: 'Abrir largo',
        openable: 'Apertura corta disponible',
        Openempty: 'Abrir corto',
        purchasable: 'Disponible para compra',
        vendibility: 'Disponible para venta',
        Orderconfirmation: 'Confirmar orden',
        Averageopeningprice: 'Precio promedio de apertura',
        Marketprice: 'Precio de mercado',
        Openingquantity: 'Cantidad de apertura',
        Stoplossprice: 'Stop loss',
        stopSurplusPrice: 'Take profit',
        Averageprice: 'Precio promedio',
        buyLimtMsg2: 'Solo precios menores al mercado',
        sellLimtMsg2: 'Solo precios mayores al mercado',
        authTips: 'Complete la verificación de identidad',
        profundity: 'Profundidad',
        deal: 'Operaciones',
        contract: 'Contrato',
        TradeNow: 'Operar ahora',
        CloseTime: 'Cierre de la ciudad',
        buyUp: 'Comprar al alza',
        buyDown: 'Comprar a la baja',
        selectSeconds: 'Seleccionar tiempo de vencimiento',
        buyNums: 'Monto de compra',
        minbuyNums: 'Compra mínima',
        incomeRates: 'Tasa de rendimiento',
        buySuccessTips: 'Compra exitosa',
        secondNums: 'Segundos',
        simulatedTrading: 'Trading Simulado',
    },
    upPassword: {
        title: 'Cambiar clave',
        oldPassword: 'Clave actual',
        oldPasswordMsg: 'Ingrese clave actual',
        newPassword: 'Nueva clave',
        newPasswordMsg: 'Ingrese nueva clave',
        twoPassword: 'Confirmar clave',
        twoPasswordMsg: 'Ingrese clave nuevamente',
        twoinputMsg: 'Las claves no coinciden',
        passwordTypeMsg: 'La contraseña debe tener 6 dígitos',
        submsg: 'Cambio exitoso',
        btn: 'Confirmar cambio',
    },
    user: {
        Avatarchange: 'Cambiar avatar',
        Replacesuccessfully: 'Cambio exitoso',
        authenticated: 'Verificado',
        Notcertifiedyet: 'No verificado',
        Invitefriends: 'Invitar amigos',
        Activecenter: 'Centro de actividades',
        Identityauthentication: 'Verificación identidad',
        Completedverification: 'completada',
        Tobeverified: 'Pendiente',
        SecuritySettings: 'Seguridad',
        Lang: 'Seleccionar idioma',
        changeTheme: 'Cambiar tema',
        helpcenter: 'Centro de ayuda',
        Aboutus: 'Sobre nosotros',
        out: 'Salir',
        outmsg: 'Confirmar cierre de sesión',
        trustscore: 'Puntuación de crédito',
    },
    welcome: {
        title1: 'Liderando en liquidez de mercado',
        tips1: '99% de órdenes ejecutadas al mejor precio',
        title2: '12 años de confianza',
        tips2: 'Opera criptomonedas en una plataforma confiable',
        title3: 'Beneficios VIP exclusivos',
        tips3: 'Descuentos en comisiones de trading y retiros',
        title4: '100,000 USDT en trading simulado',
        tips4: 'Practica sin riesgos',
        bnt1: 'Regístrate y gana 10 USDT',
        bnt2: 'Iniciar sesión',
    },
    with: {
        Withdrawcurrency: 'Retiro cripto',
        currencyofwithdrawal: 'Moneda de retiro',
        Withdrawaladdress: 'Dirección de retiro',
        Addwithdrawaladdress: 'Añadir dirección',
        Withdrawalquantity: 'Cantidad a retirar',
        availablebalance: 'Saldo disponible',
        WithdrawaladdressTips: 'No hay dirección configurada, ¿desea agregar?',
        selectWithdrawaladdress: 'Seleccione dirección de retiro',
        Insufficientavailablebalance: 'Saldo insuficiente',
        Withdrawingfiatcurrency: 'Retiro fiat',
        Withdrawaloffiatcurrency: 'Retiro de moneda fiat',
        Currentbalance: 'Saldo actual',
        Currencyreceived: 'Moneda recibida',
        WithdrawingfiatcurrencyTips: 'Retiros > 200USD, procesamiento rápido',
        Withdrawalaccount: 'Cuenta de retiro',
        Fiatcontractaccount: 'Cuenta contrato Fiat',
        Withdrawalamount: 'Monto de retiro',
        Youneedwithdrawmoney: 'Debe retirar',
        Youwillget: 'Recibirá',
        Withdrawimmediately: 'Retirar ahora',
        mixAmount: 'Mín. retiro ',
        subMsg: 'Enviado, espere revisión',
    },
}